function escapeAttribute(value) {
  return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? [] : _ref$images;
  if (!Array.isArray(images) || images.length === 0) {
    return '';
  }
  var safeImages = images.filter(function (img) {
    if (typeof img !== 'string' || !img.trim()) {
      return false;
    }
    var trimmed = img.trim();
    if (/[\s<>]/.test(trimmed)) {
      return false;
    }
    if (/^(javascript|vbscript):/i.test(trimmed)) {
      return false;
    }
    if (/^data:/i.test(trimmed)) {
      return /^data:image\//i.test(trimmed) && !/^data:image\/svg/i.test(trimmed);
    }
    return /^(https?:\/\/|\/(?!\/))/i.test(trimmed);
  });
  if (!safeImages.length) {
    return '';
  }
  var count = Math.min(safeImages.length, 4);
  var items = safeImages.slice(0, 4).map(function (img, index) {
    return "\n        <figure class=\"item\">\n          <img\n            src=\"".concat(escapeAttribute(img), "\"\n            alt=\"Tweet image ").concat(index + 1, " of ").concat(count, "\"\n            loading=\"lazy\"\n            data-index=\"").concat(index, "\"\n            role=\"button\"\n            tabindex=\"0\"\n          />\n        </figure>");
  }).join('');
  return "\n    <div class=\"gallery count-".concat(count, "\">\n      <div class=\"grid\">\n        ").concat(items, "\n      </div>\n    </div>\n  ");
};